<div class="component-container action-button-wrapper p-overflow-hidden">
    <custom-panel (componentReset)="reset()" [header]="'Regały'" class="flex flex-grow" resetButtonText="Anuluj" (componentSave)="save()" [areButtons]="true">
        <div panel-body style="display: flex;">
            <div class="newtable-wrapper">
                <p class="title" *ngIf="title">{{title}}</p>
                <p-table
                    #dt
                    class="pr-table"
                    [columns]="selectedColumnsControl.value"
                    [value]="tableData"
                    [loading]="isLoading"
                    [resizableColumns]="true"
                    [lazy]="true"
                    (onLazyLoad)="this.loadData($event)"
                    [paginator]="true"
                    [rows]="25"
                    [rowsPerPageOptions]="[25, 50, 100]"
                    selectionMode="single"
                    [reorderableColumns]="true"
                    [totalRecords]="this.totalRecords"
                    [scrollable]="true"
                    stateStorage="local"
                    [stateKey]="tableId"
                    (onColReorder)="this.onColReorder($event)"
                    (onColResize)="this.onColResize($event)"
                >
                    <ng-template pTemplate="colgroup" let-columns>
                        <colgroup>
                            <col
                                *ngFor="let col of columns"
                                [style.width]="col?.width + '%'"
                            >
                        </colgroup>
                    </ng-template>

                    <ng-template pTemplate="caption">
                        <div class="table-header" fxLayout="row" fxLayoutAlign="space-between center">
                            <div fxFlex fxLayoutGap="10px">
                                <button mat-button (click)="resetTable()">
                                    <mat-icon
                                        class="text-primary"
                                    >
                                        settings_backup_restore
                                    </mat-icon>
                                </button>
                                <p-multiSelect [options]="columnsData" [formControl]="selectedColumnsControl"
                                               optionLabel="header"
                                               selectedItemsLabel="{0} columns selected" [style]="{maxWidth: '200px'}"
                                               defaultLabel="Choose Columns"></p-multiSelect>
                            </div>

                            <div fxLayout="row"
                                 fxLayoutAlign="center center"
                                 fxFlex
                                 fxLayoutGap="10px"
                            >
                                <div
                                    class="search-wrapper"
                                    fxLayout="row"
                                    fxLayoutAlign="center center"
                                    fxFlex
                                >
                                    <input
                                        matInput
                                        #filter
                                        placeholder="Wpisz szukaną frazę"
                                        class="search-bar"
                                        [formControl]="filterGlobalControl"
                                    />
                                    <mat-icon class="text-primary" (click)="clearGlobalFilter()">close</mat-icon>
                                    <mat-icon
                                        class="text-primary"
                                        (click)="dt.filterGlobal(filterGlobalControl.value, 'contains')"
                                    >
                                        search
                                    </mat-icon>
                                </div>

                                <div
                                    *ngIf="extraHeaderFieldTmpl"
                                    class="extra-header-field"
                                >
                                    <ng-container *ngTemplateOutlet="extraHeaderFieldTmpl;"></ng-container>
                                </div>
                            </div>
                        </div>
                    </ng-template>

                    <ng-template pTemplate="header" let-columns>
                        <tr>
                            <th
                                *ngFor="let col of columns"
                                pResizableColumn
                                pReorderableColumn
                                [pSortableColumn]="col.field"
                                [pSortableColumnDisabled]="col.showSort === false"
                            >
                                <ng-container>
                                    <div fxLayout="row" fxLayoutAlign="center center">
                                        <div fxLayout="column" fxFlex="none">{{ col.header }}</div>
                                        <p-sortIcon fxFlex="none" *ngIf="col.showSort !== false" [field]="col.field"></p-sortIcon>
                                    </div>
                                </ng-container>

                                <pr-select-by-column
                                    [column]="col"
                                    [dt]="dt"
                                ></pr-select-by-column>
                            </th>
                        </tr>
                    </ng-template>

                    <ng-template pTemplate="body" let-row let-columns="columns">
                        <tr (click)="goToUrl(row)">
                            <td
                                [ngClass]="'pr-table-coltype-' + column.dataType"
                                class="ui-resizable-column XXX"
                                *ngFor="let column of columns; let i = index"
                            >

                                <div *ngIf="column.columnDef == 'Meters'">
                                    {{ getMetersSum(row) }}
                                </div>

                                <div *ngIf="column.columnDef == 'shelf'">
                                    <mat-form-field fxFlex="20%">
                                        <mat-label>
                                            Ilość
                                        </mat-label>
                                        <input type="number" step="1" min="0" matInput [(ngModel)]="row[column.field].Count">
                                    </mat-form-field>

                                    <mat-form-field fxFlex="80%" class="pl-xxxs">
                                        <mat-label>
                                            Rodzaj regału
                                        </mat-label>
                                        <mat-select [compareWith]="compareShelves" [(ngModel)]="row[column.field].Shelf" >
                                            <mat-option [value]="null"></mat-option>
                                            <div *ngFor="let value of shelves">
                                                <mat-option [value]="value">
                                                    {{ value.Name }}
                                                </mat-option>
                                            </div>
                                        </mat-select>
                                    </mat-form-field>
                                </div>

                                <div *ngIf="column.field !== customCellName && !column.suffix && !column.type && column.columnDef !== 'shelf'"
                                     [matTooltip]="getTooltip(column, row[column.columnDef])"
                                     [matTooltipDisabled]="!column.tooltipEnabled">
                                    {{ row[column.field] || '-' }}
                                </div>
                                <div
                                    *ngIf="column.field !== customCellName && column.suffix && column.suffix === 'currency'"
                                    [matTooltip]="getTooltip(column, row[column.columnDef])"
                                    [matTooltipDisabled]="!column.tooltipEnabled"
                                    class="currency-suf"
                                >
                                    {{ (row[column.field] | number: '.2-2') || '-' }}
                                </div>
                                <div
                                    *ngIf="column.field !== customCellName && column.type && column.type === 'margin'"
                                    [matTooltip]="getTooltip(column, row[column.columnDef])"
                                    [matTooltipDisabled]="!column.tooltipEnabled"
                                    class="percentage-suf"
                                >
                                    {{
                                    generalService.parseVAT(row[column.field])
                                        | number: '.1-1'
                                    }}
                                </div>
                                <div *ngIf="column.field !== customCellName && column.type && column.type === 'boolean'" fxLayout="row" fxLayoutAlign="center center">
                                    <p-triStateCheckbox [(ngModel)]="row[column.field]" [ngClass]="{'true-val': row[column.field], 'false-val': row[column.field] === false, 'null-val': row[column.field] === null}"></p-triStateCheckbox>
                                </div>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </div>
    </custom-panel>
</div>
